var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "welcome-card"
  }, [_c('div', {
    staticClass: "welcome-title"
  }, [_c('div', {
    staticClass: "welcome-title-left-container"
  }, [_c('Icon', {
    attrs: {
      "src": _vm.iconQuestion
    }
  }), _vm.title ? _c('p', {
    staticClass: "card-title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e()], 1), _vm.list.length > 3 && !_vm.showAllRobotWelcomeItems ? _c('div', {
    staticClass: "change-wrapper",
    on: {
      "click": function ($event) {
        return _vm.changeBranchList();
      }
    }
  }, [_c('Icon', {
    attrs: {
      "src": _vm.iconRefresh
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "welcome-items-container"
  }, [_vm._l(_vm.showList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "welcome-item",
      on: {
        "click": function ($event) {
          return _vm.handleContentListItemClick(item);
        }
      }
    }, [_c('div', {
      staticClass: "item-container"
    }, [_c('div', {
      staticClass: "item-content"
    }, [_vm._v(_vm._s(item.content))])])]);
  }), _c('div', {
    staticClass: "welcome-item welcome-item-hidden"
  }, [_vm._v(" " + _vm._s(_vm.longestContent) + " ")])], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }